<template>
  <v-container>
    <v-row class="text-center" justify="center">
      <!-- Countdown Timer Card -->
      <v-col cols="12" md="4">
        <v-card
          style="border: 3px solid #CC48CE; background: rgba(0, 0, 0, 0.6); height: 100%;"
          class="pa-4 d-flex flex-column justify-center"
        >
          <h2 class="white--text basker-text mb-4">Event Starts In</h2>
          <div v-if="eventDateTime && !eventPassed" class="countdown-container">
            <div class="countdown-item">
              <span class="countdown-value">{{ countdown.days }}</span>
              <span class="countdown-label white--text basker-text">Days</span>
            </div>
            <div class="countdown-item">
              <span class="countdown-value">{{ countdown.hours }}</span>
              <span class="countdown-label white--text basker-text">Hours</span>
            </div>
            <div class="countdown-item">
              <span class="countdown-value">{{ countdown.minutes }}</span>
              <span class="countdown-label white--text basker-text">Minutes</span>
            </div>
            <div class="countdown-item">
              <span class="countdown-value countdown-seconds">{{ countdown.seconds }}</span>
              <span class="countdown-label white--text basker-text">Seconds</span>
            </div>
          </div>
          <h2 v-else-if="eventPassed" class="white--text basker-text">Event Has Started!</h2>
          <p v-else class="white--text basker-text">Coming Soon</p>
          <ColorButton :url="generalTicketLink" text="Get Tickets" class="mt-4"></ColorButton>
        </v-card>
      </v-col>

      <!-- Event Info Card -->
      <v-col cols="12" md="4">
        <v-card
          style="border: 3px solid #CC48CE; background: rgba(0, 0, 0, 0.6); height: 100%;"
          class="pa-4"
        >
          <v-img
            :src="eventImage || require('../assets/2024-Batt.jpg')"
            style="overflow: visible; max-width: 400px; margin: 0 auto;"
          >
          </v-img>
          <h2
          class="white--text basker-text"
          > Do you have what it takes to be the next <span style="white-space: nowrap;">Battle Royale Champion?</span> </h2>
          <h1      class="white--text">
              {{formattedEventDate}}
          </h1>
          <h1  class="white--text">
            Club Cafe
            </h1>
          <p class="white--text basker-text">Club Cafe: 209 Columbus Avenue, Boston, MA. 02116</p>
          <p  class="white--text basker-text">Charity Beneficiary: {{charityBenefactor}}</p>
        </v-card>
      </v-col>

      <!-- Event Description Card -->
      <v-col cols="12" md="4">
        <v-card
          style="border: 3px solid #CC48CE; background: rgba(0, 0, 0, 0.6); height: 100%; max-height: 600px; overflow-y: auto;"
          class="pa-4 text-left"
        >
          <template v-if="descriptionBlocks && descriptionBlocks.length > 0">
            <template v-for="(block, index) in descriptionBlocks">
              <h3
                v-if="block.type === 'header'"
                :key="'h-' + index"
                class="basker-text mb-2"
                :class="{ 'mt-4': index > 0 }"
                :style="'color: ' + (block.color === 'purple' ? '#CC48CE' : '#ffdd00') + ' !important;'"
              >{{ block.text }}</h3>
              <p
                v-else
                :key="'p-' + index"
                class="white--text basker-text body-2"
              >{{ block.text }}</p>
            </template>
          </template>
          <p v-else class="white--text basker-text">Event description coming soon...</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ColorButton from '@/components/ColorButton'
import { mapState } from 'vuex'

  export default {
    name: 'HelloWorld',
    data() {
      return {
        countdown: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        },
        eventPassed: false,
        countdownInterval: null
      }
    },
    computed: {
      ...mapState([
        'charityBenefactor',
        'eventDate',
        'doorsTime',
        'eventTime',
        'doorFee',
        'onlineFee',
        'vipFee',
        'vipTicketLink',
        'generalTicketLink',
        'theme',
        'prizeAmount',
        'descriptionBlocks',
        'eventImage'
      ]),
      getImgSize () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 12
          case 'sm': return 12
          case 'md': return 4
          case 'lg': return 4
          case 'xl': return 4
        }
      },
      eventDateTime() {
        if (!this.eventDate || !/^\d{4}-\d{2}-\d{2}$/.test(this.eventDate)) return null

        const [year, month, day] = this.eventDate.split('-').map(Number)

        let hours = 12, minutes = 0
        if (this.doorsTime && /^\d{2}:\d{2}$/.test(this.doorsTime)) {
          [hours, minutes] = this.doorsTime.split(':').map(Number)
        }

        const combined = new Date(year, month - 1, day, hours, minutes)
        return isNaN(combined.getTime()) ? null : combined
      },
      formattedEventDate() {
        if (!this.eventDate || !/^\d{4}-\d{2}-\d{2}$/.test(this.eventDate)) return ''
        const [year, month, day] = this.eventDate.split('-')
        const months = ['January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December']
        const dayNum = parseInt(day, 10)
        const suffix = ['th', 'st', 'nd', 'rd'][(dayNum % 10 > 3 || Math.floor(dayNum % 100 / 10) === 1) ? 0 : dayNum % 10]
        return `${months[parseInt(month, 10) - 1]} ${dayNum}${suffix}, ${year}`
      }
    },
    watch: {
      eventDateTime: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.startCountdown()
          }
        }
      }
    },
    methods: {
      startCountdown() {
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval)
        }
        this.updateCountdown()
        this.countdownInterval = setInterval(() => {
          this.updateCountdown()
        }, 1000)
      },
      updateCountdown() {
        if (!this.eventDateTime) return

        const now = new Date().getTime()
        const target = this.eventDateTime.getTime()
        const difference = target - now

        if (difference <= 0) {
          this.eventPassed = true
          this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 }
          if (this.countdownInterval) {
            clearInterval(this.countdownInterval)
          }
          return
        }

        this.eventPassed = false
        this.countdown.days = Math.floor(difference / (1000 * 60 * 60 * 24))
        this.countdown.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.countdown.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        this.countdown.seconds = Math.floor((difference % (1000 * 60)) / 1000)
      }
    },
    beforeDestroy() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
      }
    },
    components: {
      ColorButton,
    },
  }
</script>

<style scoped>
p {
  overflow-wrap: normal;
}

.countdown-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 70px;
}

.countdown-value {
  font-size: 2.5rem;
  font-weight: bold;
  color: #CC48CE;
}

.countdown-seconds {
  color: #ffdd00;
}

.countdown-label {
  font-size: 0.9rem;
  text-transform: uppercase;
}
</style>
